/**
 * OS CENÁRIOS PRONTOS DA PRATELEIRA — T11.6.
 *
 * O ponto: *"Biblioteca de personagens e cenários — Não atende"*. Até 06/10/2026 a prateleira de
 * Cenários só mostrava o que a própria criança tinha gerado, e abria vazia para quem começava.
 *
 * Os seis desenhos abaixo foram gerados de graça pelo desenhista principal, sem pessoa e sem marca
 * d'água, e o operador escolheu em chat: *«Entram todos os cenários»*.
 *
 * ── POR QUE O ID TEM PREFIXO, E NÃO É UMA IMAGEM DA CONTA ────────────────────────────────────
 *
 * O quadrinho guarda só o `imgId` de cada item, e descobre o endereço ao reabrir, por
 * `AppUser.getImgUrl`. Uma imagem da conta mora em `users/{uid}/imgs`; estas moram no próprio
 * produto, iguais para todo mundo. O prefixo `pronto:` é o que deixa `getImgUrl` reconhecê-las num
 * lugar só — e assim elas aparecem ao inserir, ao reabrir e ao publicar, pelo mesmo caminho.
 */
import salaDeAula from "../assets/cenarios/sala-de-aula.jpg";
import patio from "../assets/cenarios/patio.jpg";
import casa from "../assets/cenarios/casa.jpg";
import rua from "../assets/cenarios/rua.jpg";
import natureza from "../assets/cenarios/natureza.jpg";
import laboratorio from "../assets/cenarios/laboratorio.jpg";

export interface CenarioPronto {
  id: string;
  nome: string;
  url: string;
}

const PREFIXO = "pronto:";

export const CENARIOS_PRONTOS: CenarioPronto[] = [
  { id: `${PREFIXO}sala-de-aula`, nome: "Sala de aula", url: salaDeAula },
  { id: `${PREFIXO}patio`, nome: "Pátio da escola", url: patio },
  { id: `${PREFIXO}casa`, nome: "Sala de casa", url: casa },
  { id: `${PREFIXO}rua`, nome: "Rua", url: rua },
  { id: `${PREFIXO}natureza`, nome: "Natureza", url: natureza },
  { id: `${PREFIXO}laboratorio`, nome: "Laboratório", url: laboratorio },
];

export function ehCenarioPronto(id: unknown): id is string {
  return typeof id === "string" && id.startsWith(PREFIXO);
}

/** O endereço do cenário pronto, ou "" quando o id não é de nenhum dos seis. */
export function urlDoCenarioPronto(id: string): string {
  return CENARIOS_PRONTOS.find((c) => c.id === id)?.url ?? "";
}
